export const SizeLengthSelectComponent = {
  name: 'quickshop-size-length-dropdown',
  template: `#quickshop-size-length-dropdown`,
  props: ['label', 'position', 'options', 'selectedValue'],
  updated() {

    this.$nextTick(function () {
      $('select.custom-styled-dropdown').niceSelect('destroy');
      if (this.options.length) {

        setTimeout(() => {
          $('select.custom-styled-dropdown').niceSelect();
        }, 100);
      } else {
        $('select.custom-styled-dropdown').niceSelect('update');
      }
    });
  },
  computed: {
    dropdown: {
      get() {
        return this.selectedValue;
      },
      set(val) {
        this.$emit('changeSizeLengthSelect', val);
      },
    },
  },
};
